import type { RaceConfig } from '@/core/types';
import { raceConfig as ehime2026 } from './ehime2026';

const races: Record<string, RaceConfig> = {
  ehime2026,
};

export function getRaceConfig(alias: string): RaceConfig | undefined {
  return races[alias];
}

export function getAllRaceAliases(): string[] {
  return Object.keys(races);
}
